const groupBy = (data, field, { asList = false } = {}) => {
  const result = (data ?? []).reduce((accumulator, row) => {
    const groupby = typeof field === 'function' ? field(row) : field
    accumulator[groupby] = accumulator[groupby] || []
    accumulator[groupby].push(row)
    return accumulator
  }, {})
  return asList ? Object.entries(result) : result
}

export default groupBy
